import { NoopExiting } from '@/features/common/components/Toast/animations'
import { exitingAnimationDurationMs } from '@/features/common/components/Toast/constants'
import { ExitAnimationFunction } from '@/features/common/components/Toast/types'
import { Platform } from 'react-native'
import { LightSpeedOutLeft, SharedValue, runOnJS } from 'react-native-reanimated'

export const getExitingAnimation = (
    wasSwiped: SharedValue<boolean>,
    onExitingAnimationEnd: () => void
): LightSpeedOutLeft | ExitAnimationFunction => {
    const handleExitingAnimationEnd = () => {
        'worklet'
        runOnJS(onExitingAnimationEnd)()
    }

    const lightSpeedOutLeftAnimation = LightSpeedOutLeft.duration(
        exitingAnimationDurationMs
    ).withCallback(handleExitingAnimationEnd)

    const builtLightSpeedOutLeftAnimation =
        lightSpeedOutLeftAnimation.build() as ExitAnimationFunction

    const ExitingAnimation: ExitAnimationFunction = (values) => {
        'worklet'

        return !wasSwiped.value ? builtLightSpeedOutLeftAnimation(values) : NoopExiting(values)
    }

    return Platform.OS === 'web' ? lightSpeedOutLeftAnimation : ExitingAnimation
}
